import type { MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"

export type ExtraCostVehicleConditionMode = "ALL" | "NEW_ONLY"

export const getExtraCostVehicleConditionMode = (key: MarketplaceKey): ExtraCostVehicleConditionMode => {
	if (key === "us") {
		return "NEW_ONLY"
	}

	return "ALL"
}
